import React from 'react';
import { TopNavbar } from './TopNavbar';

interface AppLayoutProps {
  children: React.ReactNode;
  showNavbar?: boolean;
  showLanguageSwitcher?: boolean;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ 
  children, 
  showNavbar = true,
  showLanguageSwitcher = true
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-secondary/20 to-accent/20">
      {showNavbar && <TopNavbar showLanguageSwitcher={showLanguageSwitcher} />}
      {children}
    </div>
  );
};